/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI
 * Copyright IBM Corp. 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

define([
	'react',
	'react-dom',
	'prop-types',
	'ba-ui-carbon',
	'./ProfileTab',
	'./SettingsTab',
	'../../nls/StringResources'
], (React, ReactDOM, PropTypes, Carbon, ProfileTab, SettingsTab, StringResources) => {

	const { Tabs, Tab } = Carbon;

	class ProfileAndSettings extends React.Component {

		static propTypes = {
			Glass: PropTypes.any,
			slideout: PropTypes.any
		}

		render() {
			return (
				<div className="profileAndSettings">
					<div className="profileTitle">{StringResources.get('profileAndSettings')}</div>
					<div className="profileSubtitle">{StringResources.get('updateProfileAndsettings')}</div>
					<Tabs>
						<Tab href="#" id="profile" label={StringResources.get('profile')}>
							<ProfileTab Glass={this.props.Glass} slideout={this.props.slideout}/>
						</Tab>
						<Tab href="#" id="settings" label={StringResources.get('settings')}>
							<SettingsTab Glass={this.props.Glass} slideout={this.props.slideout}/>
						</Tab>
					</Tabs>
				</div>
			);
		}
	}

	class ProfileAndSettingsBridge {

		constructor(options) {
			this.Glass = options.glassContext;
			this.slideout = options.slideout;
			this.el = this.slideout.$el[0];
		}

		show() {}

		hide() {}

		remove() {
			ReactDOM.unmountComponentAtNode(this.el);
		}

		render() {
			ReactDOM.render(
				<ProfileAndSettings
					Glass={this.Glass}
					slideout={this.slideout}
				/>,
				this.el
			);
		}
	}

	return ProfileAndSettingsBridge;

});